import { ReactElement, useMemo, useState } from 'react'
import { Heading, Text } from '../../Atoms'
import Flex from '../Flex'
import Grid from '../Grid'
import { OverviewCardProps } from './props'
import {
    StyledBottomDiv,
    StyledBtn,
    StyledOverviewCard,
    StyledTopDiv,
} from './styles'

const OverviewCard = ({
    buttons,
    amount,
    unit,
    indexOfActiveButton,
    ...props
}: OverviewCardProps): ReactElement => {
    const [isActive, setIsActive] = useState(0)

    const activeIndex = indexOfActiveButton || isActive

    const ArrayOfButtons = useMemo(() => {
        return buttons.map((button, i) => {
            return (
                <StyledBtn
                    {...button}
                    onClick={() => {
                        setIsActive(i)
                        button.onClick?.()
                    }}
                    key={i}
                    active={activeIndex === i}
                >
                    {button.text}
                </StyledBtn>
            )
        })
    }, [buttons, activeIndex])

    const heading = buttons[activeIndex].heading
    const headingDate = buttons[activeIndex].headingDate

    return (
        <StyledOverviewCard {...props}>
            <StyledBottomDiv>
                <Grid
                    gap={4}
                    css={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 'calc(100% - 1px)',
                    }}
                >
                    {ArrayOfButtons}
                </Grid>
            </StyledBottomDiv>
            <StyledTopDiv>
                <Grid
                    css={{
                        placeContent: 'start',
                        px: '$4',
                        alignContent: 'space-between',
                        h: '50%',
                        mt: '$3',
                        olor: '$neutral100',
                    }}
                >
                    <Text size={'xs'} css={{ color: '$primary500' }}>
                        {heading}
                    </Text>
                    <Heading level={6} bold css={{ mb: '$3' }} primary>
                        {headingDate}
                    </Heading>
                    <Flex direction="row" gap={16}>
                        <Text
                            css={{
                                color: '$neutral500',
                                placeSelf: 'end',
                            }}
                        >
                            {unit}
                        </Text>
                        <Heading level={3} bold primary>
                            {amount}
                        </Heading>
                    </Flex>
                </Grid>
            </StyledTopDiv>
        </StyledOverviewCard>
    )
}

export default OverviewCard
export { StyledOverviewCard }
